import React, {useEffect, useState} from 'react'
import {
	navigate ,
	Link,
	//useStaticQuery,
	//graphql
} from 'gatsby'
import {
	Button,
	Divider,
	Icon,
	Menu,
	Portal,
	Segment
} from 'semantic-ui-react'
import ShoppingCartIcon from './ShoppingCartIcon'
import Logo from './Logo'
import * as styles from './styles/header.module.css'
import SearchBar from '../SearchBar/searchBarMobile'
import UserIconMobile from './UserIconMobile'
import { resizeTimer, tabletMaxWidth } from '../../globalVar'


const MobileMenu = ({
	location: {pathname},
	location,
	token,
	cartCount,
	logout,
	children,
	recheckLoggedIn,
	arrow,
}) => {
	/* supposed to be for making a category menu
	const MenuTemp = useStaticQuery(graphql`
		query MobileMenuQuery {
			menu {
				result {
					name
					url
					children {
						squareImageHref
						name
						url
					}
				}
			}
			site {
				siteMetadata {
					siteUrl
				}
			}
		}
	`)

	const makeMenu = (item) => {
		if(item.children) {
			return (
				<React.Fragment key={item.name}>
					{item.children.length >0 ? (
						<React.Fragment>
							<Link
								to={`/${item.url}`}
								key={item.name}
								className={styles.link}
							>
								{item.name}
							</Link>
							<Divider className={styles.divider} />
						</React.Fragment>
					):(
						<React.Fragment>
							<Link
								to={`/${item.url}`}
								key={item.name}
								className={styles.link}
							>
								{item.name}
							</Link>
							<Divider className={styles.divider} />
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}else {
			return (
				<React.Fragment>
					<Link
						to={`/${item.url}`}
						key={item.name}
						className={styles.link}
					>
						{item.name}
					</Link>
					<Divider className={styles.divider} />
				</React.Fragment>
			)
		}
	}

	*/

	//const [activeItem, setActiveItem] = useState(pathname)
	const [open, setOpen] = useState(false)


	const HomeMenuList = [
		{
			"name": "Home",
			"url": "",
			"children": []
		}
	]
	const AccountMenuList = [
		{
			"name": "Orders",
			"url": "my-account/orders",
			"children": [
				{
					"name": "History",
					"url": "my-account/orders",
					"children": []
				},
				{
					"name": "Submit Payment",
					"url": "payment",
					"children": []
				},
				{
					"name": "Confirm / Approve",
					"url": "my-account/orders?list=confirm",
					"children": []
				},
			]
		},
		{
			"name": "Payment History",
			"url": "my-account/payments",
			"children": []
		}
	];
	const GuestMenuList = [
		{
			"name": "Orders",
			"url": "confirm",
			"children": [
				{
					"name": "Confirm",
					"url": "confirm",
					"children": []
				},
				{
					"name": "Payment",
					"url": "payment",
					"children": []
				},
			]
		},
	];

	const TopMenuList = [
		{
			"name": "Franchise / Distributorship",
			"url": "franchise",
			"children": []
		},
		{
			"name": "Product List",
			"url": "product-list",
			"children": [
				{
					"name": "Food",
					"url": "hamburger-foodcart",
					"children": []
				},
				{
					"name": "Non-Food",
					"url": "non-food",
					"children": []
				},
				{
					"name": "Categories",
					"url": "category",
					"children": []
				}
			]
		},
		{
			"name": "Negosyo",
			"url": "business",
			"children": []
		},
		{
			"name": "Seminars",
			"url": "seminar",
			"children": []
		},
		{
			"name": "Courses",
			"url": "course",
			"children": []
		},
		{
			"name": "Recipes, Videos and Guides",
			"url": "recipes",
			"children": [
				{
					"name": "Recipes",
					"url": "recipes",
					"children": []
				},
				{
					"name": "Stories and Tips",
					"url": "stories",
					"children": []
				},
				{
					"name": "How-To Guides",
					"url": "howto",
					"children": []
				}
			]
		},
		{
			"name": "FAQ",
			"url": "faq",
			"children": []
		}
	];

	/*
	useEffect(() => {
		setActiveItem(pathname)
	}, [pathname])
	*/

	const [screenWidth, setScreenWidth] = useState(0);

	const handleClick = () => {
		setOpen(true)
		setScreenWidth(window.innerWidth);
	}

	const handleClose = () => {
		setOpen(false)
	}

	const linkobj = (linkenty) => {
		return <Link to={linkenty.url.length > 0?"/"+linkenty.url:"/"} onClick={handleClose} className={styles.link}>
			{linkenty.name}
		</Link>
	}

	// Close mobile nav menu when screen resizes from mobile/tablet to desktop
	useEffect(() => {
		setScreenWidth(window.innerWidth);

		let timeOut = null;

		const resizeConsolidator = () => {
			clearTimeout(timeOut)
			timeOut = setTimeout(handler, resizeTimer)
		}
		
		window.addEventListener("resize", resizeConsolidator);

		return () => {
			clearTimeout(timeOut)
			window.removeEventListener("resize", resizeConsolidator)
		}
	}, [])

	const handler = () => {
		// Checks if window inner width changes
		if (screenWidth !== window.innerWidth) {
			// Checks if screen resizes to a larger screen
			if (window.innerWidth > tabletMaxWidth) {
				setOpen(false);
			}
		}
	}

	//const menu= MenuTemp.menu.result
	//const menuMarkup = menu.map(makeMenu)

	return (
		<Menu size="huge" secondary >
			{ arrow===true && (
				<Menu.Item
					header
					className={`${styles.text} ${styles.mobileItem}`}
					onClick={()=>{
						handleClose()

						/* Sept 14, 2020
						 *for when we want to add a back button also in the pages that replaces history using navigate replace:true(changePassword, forgot-password, etc) since the location.key isn't inherited by the new page even when the window.history gets replaced
						 *caution not fully tested, not sure if this will break the back button since only tested a bit in paolowfh server and not in demo/live
						if(location.state) {
							if(location.state.customKey) {
								if( location.state.customKey!=="initial" ) {
									window.history.back()
								}else {
									navigate('/')
								}
							}else {
								if( location.key!=="initial" ) {
									window.history.back()
								}else {
									navigate('/')
								}
							}
						}
						else if( location.key!=="initial" ) {
							window.history.back()
						}else {
							navigate('/')
						}
						*/

						/*
							won't be able to check for gatsby navigate/Link simple replace since the key isn't inherited
							also won't be able to skip certain pages since goBackNum isn't recorded
						*/
						if( location.key!=="initial" ) {
							window.history.back()
						}else {
							navigate('/')
						}
						//https://www.choosepizzi.net/jquery-back-button-that-prevent-going-out-from-site/
						//https://github.com/gatsbyjs/gatsby/issues/10410
						/* //version 2/3 can be used for skipping certain page using window.history.go and the custom variable window.goBackNum
						//only uncomment and use this if we need to skip certain pages
						var referrer = window.previousPath;
						var siteUrl = MenuTemp.site.siteMetadata.siteUrl

						var goBack = window.goBackNum //for skipping certain page
						if( referrer.indexOf(siteUrl) !== -1 ) {
							if(window.history.length > 1 ) { //not opened through open with new tab or target_blank, may not be applicable anymore if change if statement above this to also check location.key==="initial"
								//window.history.go(goBack[goBack.length-1]) //for skipping certain page
								window.history.back()
							}else {
								navigate('/');//assumed to be from open in new tab reference aka document.refferer
							}

							//window.location.href=referrer;
						}else {
							navigate('/');
						}
						*/

					}}
				>
					<Icon name="arrow left"/>
				</Menu.Item>
			)}

			<Menu.Item
				as={Link}
				to="/"
				header
				className={`${styles.text} ${styles.mobileItem}`}
				onClick={handleClose}
			>
				<Logo />
				{ (arrow===false || arrow===undefined) && (
					<React.Fragment>
						NegosyoNow
					</React.Fragment>
				)}

			</Menu.Item>
			<Menu.Menu position="right">
				<Menu.Item className={styles.mobileItem} >
					<SearchBar closeModal={handleClose}/>
				</Menu.Item>
				<Menu.Item
					as={Link}
					to="/cart/"
					className={styles.mobileItem}
					onClick={handleClose}
				>
					<ShoppingCartIcon cartCount={cartCount}/>
				</Menu.Item>
				{token && (
					<UserIconMobile closeModal={handleClose}/>
				)}
				<Menu.Item className={styles.mobileItem}>
					<Button
						onClick={open ? handleClose:handleClick}
						aria-label={open ? "Close Navigation":"Open Navigation Menu"}
						className={styles.burgerButton}
						name={"mobileMenu"}
					>
						<Icon fitted name={open ? "cancel":"bars"} className={styles.icon}/>
					</Button>
				</Menu.Item>
			</Menu.Menu>
			<Portal open={open}>
				<Segment role="dialog" aria-label="Navigation Menu" className={styles.segment}>
					<div className={styles.div+" "+styles.mobileMenu} >
						<>{
							HomeMenuList.concat(token?AccountMenuList:GuestMenuList).concat(TopMenuList).map((menuentry, menuentryidx)=> {
								return <>
									{menuentryidx>0 && <Divider className={styles.divider} />}
									{linkobj(menuentry)}
									{menuentry.children.length > 0 && <>
										<br/>
										{menuentry.children.map((submenuentry, submenuentryidx) => {
											return <>
													{submenuentryidx>0&&<>&nbsp;&nbsp;|&nbsp;&nbsp;</>}
													{linkobj(submenuentry)}
												</>
										})}
									</>}
								</>
							})
						}</>
						<Divider className={styles.divider} />
						{token ? [

							<Link //maybe make this not a link
								to="/"
								onClick={()=>logout()
									.then( ()=>{
										recheckLoggedIn()
										navigate("/")
									}).catch((err)=>{

									})
								}
								key={3}
								className={styles.link}
								name={"signOutOption"}
							>
								Sign Out
							</Link>,
						] : [
							<Link to="/register/" onClick={handleClose} key={1} className={styles.link}>
								Sign Up / Sign In
							</Link>
						]}
					</div>
				</Segment>
			</Portal>
		</Menu>
	)
}

export default MobileMenu

/*active={activeItem === withPrefix('/cart/')}*/
